<template>
  <div class="video-content">
    <div
      v-if="uploaderDes"
      class="video-header"
    >
      <div class="video-top-bg">
        <img :src="uploaderDes.v_picurl">
        <div class="mask" />
      </div>
      <div class="header-wrap">
        <header>
          <div class="icon-gather-left">
            <i
              class="sub-page-back"
              uigs="head_back"
              @click="backPrev"
            />
          </div>
          <h4>作者视频</h4>
          <div class="icon-gather-right">
            <i
              class="sub-page-home"
              uigs="head_home"
              @click="jump2Home"
            />
            <i
              class="sub-page-search"
              uigs="head_search"
              @click="jump2Search"
            />
          </div>
        </header>
        <a
          class="img-flex space-between"
          :href="uploaderDes.pageurl"
        >
          <div class="img-layout">
            <i class="img-height img-square">
              <img :src="uploaderDes.v_picurl">
            </i>
            <span class="v-tag" />
          </div>
          <div class="text-layout">
            <h4 class="fz-big">{{ uploaderDes.name }}</h4>
            <div class="citeurl">
              <span v-if="uploaderDes.fans_num">{{ uploaderDes.fans_num }}粉丝</span>
              <span v-if="uploaderDes.video_count">{{ uploaderDes.video_count }}个视频</span>
            </div>
          </div>
        </a>
        <p class="video-wiki clamp2">
          <span>{{ uploaderDes.introduction }}</span>
          <a
            v-if="false"
            href="#"
            class="more"
          >详情</a>
        </p>
      </div>
    </div>
    <div class="vrResult video-list video-list-top">
      <div class="video-tab">
        <ul>
          <li
            :class="['fz-title', { active: orderActive }]"
            @click="getShortVideoByOrder('1')"
          >
            最新
          </li>
          <li
            :class="['fz-title', { active: !orderActive }]"
            @click="getShortVideoByOrder('0')"
          >
            最热
          </li>
        </ul>
        <div class="select-common select-common-noline">
          <i>
            <img
              :src="'https://dlweb.sogoucdn.com/video/wap/static/img/logo/' + uploaderDes.icon"
              width="14"
            >
          </i>
          <p class="select-text">
            {{ uploaderDes.siteName }}
          </p>
        </div>
      </div>
      <div class="list-img-flex">
        <a
          v-for="(item, i) in uploaderShortVideoList"
          :key="'video' + i"
          class="img-flex space-between"
          :href="item.playlink"
        >
          <div class="img-layout">
            <i class="img-height">
              <img :src="item.v_picurl">
              <span class="about-tag">{{ item.duration }}</span>
            </i>
          </div>
          <div class="text-layout">
            <h4 class="fz-title clamp2">{{ item.title }}</h4>
            <div class="citeurl">
              <span class="ellipsis">{{ item.pub_date }}</span>
              <span class="ellipsis">{{ item.play }}人次观看</span>
            </div>
          </div>
        </a>
      </div>
      <a
        v-if="showMoreTag"
        class="slide-down"
        href="javascript:void(0);"
        @click="showMoreVideo"
      >查看更多</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import { getSpver } from '../../common/js/util';

export default {
  data() {
    return {
      orderActive: true,
      showMoreTag: true,
      detailBtnShow: false,
    };
  },
  computed: {
    ...mapState('uploader', ['itemData']),
    uploaderDes() {
      return (this.itemData && this.itemData.uploaderDesData) || '';
    },
    uploaderShortVideoList() {
      const uploaderShortVideoData = (this.itemData && this.itemData.uploaderShortVideoData) || [];
      if (uploaderShortVideoData.length) {
        if (this.showMoreTag) {
          return this.itemData.uploaderShortVideoData.slice(0, 5);
        }
        return this.itemData.uploaderShortVideoData;
      }
      return [];
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('detail/prefetchData', { context, route })
      .catch(err => console.log('[DETAIL_CARTOON_PREFETCH_ERROR]', err));
  },
  mounted() {
    this.showDetailBtn();
  },
  methods: {
    getShortVideoByOrder(order) {
      const self = this;
      // 查看更多show
      self.showMoreTag = true;
      if (order === '1') {
        self.orderActive = true;
      } else {
        self.orderActive = false;
      }
      const { uuid = '' } = window.UIGS_PARA;
      const { key = '' } = self.$route.query;
      // 请求接口获取视频数据(order: 0:播放量排序(最热) / 1:时间排序(最新))
      axios('/napi/video/uploader/shortVideo', {
        params: {
          key,
          uuid,
          order,
        },
      }).then((res) => {
        const { data } = res;
        if (data && data.length) {
          self.itemData.uploaderShortVideoData = data;
        }
      });
    },
    jump2Home() {
      window.location.href = `/?source=node&spver=${this.spver()}`;
    },
    jump2Search() {
      window.location.href = `/hotsugg?spver=${this.spver()}`;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
    backPrev() {
      history.go(-1);
      return false;
    },
    showMoreVideo() {
      this.showMoreTag = false;
    },
    // 详情按钮展示
    showDetailBtn() {
      if (+this.$route.query.detail === 1) {
        this.detailBtnShow = true;
      }
    },
  },
};
</script>
